import { baseApi, baseRequest } from '@alltrails/redux-helpers/baseApi';
import { getFallFoliageStyle } from '../requests/getFallFoliageStyle';
import type { FallFoliageStyle } from '../utils/fallFoliageLayers';

export const advancedMapLayersApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // The overlay renders the layers and the legend renders the gradient and week controls, so both read
    // this style. Keeping it in the RTK Query cache gives them one shared request, and a retry from the
    // overlay's error toast updates the legend too.
    getFallFoliageStyle: builder.query<
      FallFoliageStyle,
      {
        publicBaseUrl: string;
        isFreeOverlay?: boolean;
      }
    >({
      queryFn: ({ publicBaseUrl, isFreeOverlay }) => baseRequest(() => getFallFoliageStyle(publicBaseUrl, isFreeOverlay))
    })
  })
});

export const { useGetFallFoliageStyleQuery } = advancedMapLayersApi;
